import type { ReactElement } from 'react';
import type { NoteHandoffChip } from '../lib/note-handoff';

/** Visible preview of a note staged into Main Command. Not a second composer. */
export function NoteHandoffChipView({
  chip,
  draftText,
  onDismiss,
}: {
  readonly chip: NoteHandoffChip;
  readonly draftText: string;
  readonly onDismiss: () => void;
}): ReactElement {
  return (
    <div
      className="note-handoff-chip"
      data-testid="note-handoff-chip"
      data-note-id={chip.noteId}
      data-auto-send="false"
      role="status"
      aria-label={`Attached note ${chip.title}`}
    >
      <div className="note-handoff-chip-head">
        <span className="tag">Attached note</span>
        <strong>{chip.title}</strong>
        <button type="button" className="link" onClick={onDismiss}>Remove note</button>
      </div>
      <pre className="note-handoff-chip-preview">{draftText}</pre>
      <small>
        {chip.truncated
          ? 'Not sent yet. The draft was cut to the Main Command limit. Edit it, choose recipients, then Send.'
          : 'Not sent yet. Edit the draft, choose recipients, then Send.'}
      </small>
    </div>
  );
}
